import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";

const state = {
  isShowLoginDialog: false,
  isShowRegisterDialog: false,
  isBlockPopup: false
};

const mutations = {
  SHOW_DIALOG: state => {
    state.isShowLoginDialog = true;
  },
  HIDE_DIALOG: state => {
    state.isShowLoginDialog = false;
  },
  SHOW_DIALOG_REGISTER: state => {
    state.isShowRegisterDialog = true;
  },
  HIDE_DIALOG_REGISTER: state => {
    state.isShowRegisterDialog = false;
  },
  SET_BLOCK_POPUP: (state, data) => {
    state.isBlockPopup = data;
  }
};

const actions = {
  showLoginDialog({ commit }) {
    commit("SHOW_DIALOG");
  },
  hideLoginDialog({ commit }) {
    commit("HIDE_DIALOG");
  },
  showRegisterDialog({ commit }) {
    commit("SHOW_DIALOG_REGISTER");
  },
  hideRegisterDialog({ commit }) {
    commit("HIDE_DIALOG_REGISTER");
  },
  setBlockPopup({ commit }, data) {
    commit("SET_BLOCK_POPUP", data);
  },
  loginGG({ commit }) {
    return new Promise((resolve, reject) => {
      const auth = getAuth(); // Lấy đối tượng auth từ Firebase
      const provider = new GoogleAuthProvider(); // Tạo một provider cho đăng nhập bằng Google
      // Mở popup đăng nhập bằng Google
      signInWithPopup(auth, provider)
        .then(result => {
          console.log("result_________", result);
          console.log("User:", result.user.accessToken);
          resolve(result.user.accessToken)
        })
        .catch(error => {
          reject(error)
          console.log("errro________", error);
        });
    });
  }
};

export default {
  state,
  mutations,
  actions
};
